export default [
  {
    path: '/uuidUpgrade',
    component: () => import('@/views/ota/uuidUpgrade.vue'),
    name: 'upgrade',
    meta: {
      title: '仪表升级',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/uuidUpgrade2',
    component: () => import('@/views/ota/uuidUpgrade2.vue'),
    name: 'upgrade2',
    meta: {
      title: '仪表升级',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/uuidInstru',
    component: () => import('@/views/ota/uuidInstru.vue'),
    name: 'uuidInstru',
    meta: {
      title: '仪表升级',
      backgroundClass: 'bg-gray',
    },
  },
];
